import * as React from 'react';

import type { ScaledValueProps } from '../scaled-value';
import { ScaledValue } from '../scaled-value';

const BYTE_SIZE_LABELS = [
  'ui:byteSize.bytes',
  'ui:byteSize.KiB',
  'ui:byteSize.MiB',
  'ui:byteSize.GiB',
  'ui:byteSize.TiB',
  'ui:byteSize.PiB',
];

type ScaledBytesProps = {
  bytes: number;
} & Omit<ScaledValueProps, 'value' | 'base'>;

// TODO: Use pretty-byte package?
export const ScaledBytes: React.FC<ScaledBytesProps> = ({ bytes, ...rest }) => (
  <ScaledValue
    value={bytes}
    base={1024}
    sizeLabels={BYTE_SIZE_LABELS}
    {...rest}
  />
);
